if (!process.env.REACT_APP_GOOGLE_CLIENT_ID || !process.env.REACT_APP_SERVER) {
  throw new Error('undefined environement variable');
}

export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
export const SERVER = process.env.REACT_APP_SERVER;
